export const convertObjectToArray = (obj: { [key: string]: any }) => {
  if (typeof obj !== 'object') {
    return [];
  }
  return Object.keys(obj).filter((key) => obj[key]);
};
